import React, {useState, useEffect} from 'react';
import Picture from 'Shared/Picture';

const ArticleBanner = (props) => {
    const { BoxImage, BoxImageAlt, BoxTitle, BoxButtonText, BoxButtonUrl, BoxButtonTarget } = props.banner;

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        window.addEventListener('resize', checkWindowWidth);
    },[]);
    const checkWindowWidth = () => {
        setIsMobile(window.innerWidth < 768);
    }

    return (
        <React.Fragment>
            {isMobile ? (
                <div className="article-banner">
                    <a href={BoxButtonUrl.Value} target={BoxButtonTarget.Value}>
                        {BoxButtonText.Value}
                        <h4 className="title">{BoxTitle.Value}</h4>
                    </a>
                </div>
            ) : (
                <div className="article-banner">
                    <Picture src={BoxImage.Value} alt={BoxImageAlt.Value} />
                    <div className="text-box">
                        <h3 className="title heading4">{BoxTitle.Value}</h3>
                        <a href={BoxButtonUrl.Value} target={BoxButtonTarget.Value} className="button">{BoxButtonText.Value}</a>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}
export default ArticleBanner;
